import { getNow } from 'application/util/time.util';

import template from './verify-email-notification.tpl.pug';

class VerifyEmailController {
    /* @ngInject */
    constructor($timeout, emailVerificationService) {
        this.$timeout = $timeout;
        this.emailVerificationService = emailVerificationService;
    }

    $onInit() {
        this.expired = getNow() > this.expire;
    }

    resend() {
        return this.emailVerificationService.send(this.email).then(() => {
            this.message = `The email has been sent to your inbox.`;
            this.$timeout(this.close.bind(this), 3000);
        }).catch(() => null);
    }

    close() {
        return this.onClose();
    }
}

export default {
    selector: 'dbAVerifyEmailNotification',
    template: template(),
    controller: VerifyEmailController,
    bindings: {
        expire: '<',
        email: '<',
        onClose: '&'
    }
};



// WEBPACK FOOTER //
// ./src/application/component/notifications/component/verify-email-notification/verify-email-notification.cmpt.js